import React, { useState } from "react"
import { ChevronDown } from "./Icon"
import { Anchor, Button } from "antd"
const { Link } = Anchor

export default function NavigasiNews({ data, limit }) {
  const [showMore, setShowMore] = useState(limit)
  return (
    <>
      <h4 className="section-title-small">Navigasi</h4>
      <Anchor affix={false} offsetTop={80} className="anchor-menu">
        {data.slice(0, showMore).map((d, i) => {
          return (
            <Link
              key={i}
              href={"#anchor-" + i}
              title={d.content_title || d.title}
            />
          )
        })}
      </Anchor>
      {data.length === showMore && data.length > limit && (
        <Button
          onClick={() => setShowMore(limit)}
          type="link"
          style={{ marginTop: 15, marginLeft: 15 }}
          icon={
            <ChevronDown
              style={{
                color: "#FF6",
                position: "relative",
                transform: "rotate(180deg)",
                top: -5,
              }}
              twoToneColor="#FF6900"
            />
          }
        >
          TUTUP
        </Button>
      )}
      {data.length !== showMore && data.length > limit && (
        <Button
          onClick={() => setShowMore(data.length)}
          type="link"
          style={{ marginTop: 15, marginLeft: 15 }}
          icon={
            <ChevronDown
              style={{
                marginTop: 5,
                color: "#FF6",
                position: "relative",
                top: 1,
              }}
              twoToneColor="#FF6900"
            />
          }
        >
          SELEBIHNYA
        </Button>
      )}
    </>
  )
}
